export default "__VITE_PUBLIC_ASSET__afcbedb2__"